module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Money-e2547f5e4d742c61bb49b54ca8d73e8f.svg";